"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryEvent = void 0;
var HistoryEvent;
(function (HistoryEvent) {
    HistoryEvent["PUSH"] = "PUSH";
    HistoryEvent["POP"] = "POP";
    HistoryEvent["REPLACE"] = "REPLACE";
})(HistoryEvent = exports.HistoryEvent || (exports.HistoryEvent = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvaGlzdG9yeS90eXBlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxJQUFZLFlBSVg7QUFKRCxXQUFZLFlBQVk7SUFDdEIsNkJBQWEsQ0FBQTtJQUNiLDJCQUFXLENBQUE7SUFDWCxtQ0FBbUIsQ0FBQTtBQUNyQixDQUFDLEVBSlcsWUFBWSxHQUFaLG9CQUFZLEtBQVosb0JBQVksUUFJdkIifQ==